// extracted by mini-css-extract-plugin
module.exports = {"block":"info_block__1Z70S","inner":"info_inner__1G3rH","card":"info_card__yBILT","border":"info_border__2rm2t","arrow":"info_arrow__1oixL","content":"info_content__1mfZm"};